import { Dispatch } from 'react';
import { IContact, IContactReturn } from '../interface';
import { ContactStatusManager } from '../services/contactManager';
import { createContact } from '../services/index';
import { contactActions } from './definition';

// Reducers of Single Contact
function contactIsLoading() {
    return {
        type: contactActions.CONTACT_IS_LOADING,
    };
}

function newContactAdd(contact: IContactReturn) {
    return {
        type: contactActions.CONTACT_NEW,
        data: contact,
    };
}

const contactReset = () => {
    return {
        type: contactActions.CONTACT_RESET,
    };
};

function contactError(e: string, contact: IContact | string) {
    return {
        type: contactActions.CONTACT_ERROR,
        error: e,
        data: contact,
    };
}

/**
 * Reducer to create a new contact
 * @param values Data to create a new contact
 */
export const newContact = (contact: IContact) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return async (dispatch: Dispatch<any>): Promise<void> => {
        try {
            dispatch(contactIsLoading());
            const response = await createContact(contact);
            if (response?.statusCode === ContactStatusManager.CONTACT_MESSAGE_SENDED && response.data) {
                dispatch(newContactAdd(response));
            } else {
                dispatch(contactError('Could not create contact', contact));
            }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error: any) {
            if (error.response && error.response.data) {
                if (error.response.data.message && error.response.data.message.length > 0) {
                    dispatch(contactError('No se pudo crear el contacto: ' + error.response.data.message, contact));
                }
            } else {
                dispatch(contactError('No se pudo crear el contacto', contact));
            }
            //console.log('Error: creacion de el contacto!!');
            console.log(error);
        }
    };
};

/**
 * Reducer to reset Contacts
 * @param values Values to reset contacts
 */
export const resetContact = () => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return async (dispatch: Dispatch<any>): Promise<void> => {
        dispatch(contactReset());
    };
};
